import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useSelfServeContextStore } from "./SelfServeContext";
export var useSelectedBrandOrder = function useSelectedBrandOrder() {
  var _useSelfServeContextS = useSelfServeContextStore(["selectedBrandOrder"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    selectedBrandOrder = _useSelfServeContextS2[0].selectedBrandOrder;
  return {
    selectedBrandOrder: selectedBrandOrder
  };
};